import { IoFastFoodOutline } from "react-icons/io5";
import { useGetTodaysLunchMeal } from "../hooks/useGetTodaysLunchMeal";
import styled from "styled-components";

const Container = styled.div`
  display: flex;
  justify-content: baseline;
`;

const StyledLunchLabel = styled.h2`
  font-size: 1em;
  padding-top: 0.1em;
  color: var(--color-witron-blue);
  margin-left: 1em;
`;
const StyledLunchName = styled.h2`
  font-size: 1.1em;
  color: var(--color-witron-grey);
  margin-left: 1em;
`;

function TodaysLunchMeal() {
  const { data, isLoading, error } = useGetTodaysLunchMeal();

  if (error || isLoading) return;

  return (
    <Container>
      <StyledLunchLabel>Lunch Today: </StyledLunchLabel>
      <StyledLunchName>{data.mealName}</StyledLunchName>{" "}
    </Container>
  );
}

export default TodaysLunchMeal;
